import styled from 'styled-components';
import { inputStyles } from '../../styled/inputs';

const prefixSize = '36px';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
`;

export const Input = styled.input`
  ${inputStyles}
  padding-left: ${prefixSize};
  max-width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '10em')};
  width: 100%;
`;

export const CurrencySymbol = styled.span`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: ${prefixSize};
  display: flex;
  justify-content: center;
  align-items: center;
`;
